// Table keys for usePreservedTableState
export const TableKeys = {
  USER_MANAGEMENT: {
    ORGANISATION: "organisation",
    DEPARTMENT: "department",
    TEAM: "team",
    USER_TYPE: "userType",
    USER: "user",
    MODULE: "module",
  },
  MASTER: {
    CATEGORY: "category",
    SUB_CATEGORY: "subCategory",
    TYPE: "type",
    UNIT: "unit",
    GST: "gst",
    HSN_CODE: "hsnCode",
    CURRENCY: "currency",
    MAKE: "make",
    MODEL: "model",
    PRODUCT: "product",
    CUSTOMER: "customer",
    WAREHOUSE: "warehouse",
    SUPPLIER: "supplier",
    TERMS_AND_CONDITIONS: "termsAndConditions",
    SAC_CODE: "sacCode",
  },
  ENQUIRY: {
    PRODUCT: "enquiry-product-service",
    // SERVICE: "enquiry-service-service",
  },
  QUOTATION: {
    PRODUCT: {
      LOG:"quotation-log-product",
      DRAFT: "quotation-draft-product"
    },
    SERVICE: {
      LOG:"quotation-log-service",
      DRAFT: "quotation-draft-service"
    },
  },
  SALES_ORDER: {
    PRODUCT: "sales_order-log-product",
    SERVICE: "sales_order-log-service",
  },
  PURCHASE_MANAGEMENT:{
    PR:'pr',
    APRPOVED_PR:'approved-pr',
    PURCHASE_ORDER:'purchase-order'
  },

  INVENTORY: {
    IN_STOCK: {
       STOCK_OVERVIEW:'stock-overview',
       SUPPLIER_STOCK:"supplier-stock"
    },
    REORDER_LEVEL:"reorder-level"
  },
  
  WAREHOUSE:{
    STOCK_OVERVIEW:{
      DAILY_LOG:"daily-log",
      IN_STOCK: "in-stock"
    },
    ITEM_INWARD:{
      PENDING_PO:'pending-po',
      GRN:'grn',
    },
    PACKING:{
      ISSUE_PACKING:"issue-packing",
      PACKING_DONE:"packing-done"
    },
    DISPATCH:"dispatch"
  },
  PAYMENT_MANAGEMENT:{
    PRODUCT:{
      ORDER:"order-product",
      RETENTION:"retention-product",
      PBG:'pbg-product'
    },
    SERVICE:{
      ORDER:"order-service",
      RETENTION:"retention-service",
      PBG:'pbg-service'
    }
  }
};
